import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MessageService } from '../../services/message.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-close-button',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
    ],
    templateUrl: './close-button.component.html',
    styleUrl: './close-button.component.scss'
})

// закрытие диалогового окна, при наличии несохраненных измененных данных
export class CloseButtonComponent implements OnInit {
    @Input() formGroup?: FormGroup;
    @Input({required: true}) dialogRef!: MatDialogRef<any>;
    protected messagesService = inject(MessageService);
    formDirty = false;

    ngOnInit(): void {
        if (!this.formGroup) {
            return;
        }

        this.formGroup.valueChanges.subscribe(()=> {
            if (this.formGroup?.dirty) {
                this.formDirty = true;
            }
        });
    }

    closeDialog(): void {
        if (!this.formDirty) {
            this.dialogRef.close();
            return;
        }

        // Если форма "грязная", и пользователь собирается закрыть окно, спрашиваем у него подтверждение
        this.messagesService.confirmMessage({
            title: 'У вас есть несохраненные изменения!',
            text: 'Вы действительно хотите закрыть окно?',
            primaryText: 'Да',
            secondaryText: 'Отмена'
        }).subscribe((confirmed) => {
            if (confirmed) {
                this.dialogRef.close();
            }
        });
    }
}
